import Cookies from 'js-cookie';

class CartReminder {

	constructor( containerEl ) {
		this.containerEl = containerEl;

		// Open/Close actions.
		window.addEventListener( 'showcartreminder.acl', () => this.onShow() );
		window.addEventListener( 'closecartreminder.acl', () => this.onClose() );

		CartReminder.initCloseClick();
	}

	onShow() {
		const cookieVal = Cookies.get( 'closedcartreminder' );
		if ( typeof cookieVal === 'undefined' ) {
			this.containerEl.classList.add( 'en_is_active' );
		}
	}

	onClose() {
		this.containerEl.classList.remove( 'en_is_active' );
		Cookies.set( 'closedcartreminder', 'true', {expires: 1, path: '/'} );
	}


	// GLOBAL EVENT HANDLERS.
	static clickInit = false;
	static initCloseClick() {
		if ( ! CartReminder.clickInit ) {
			CartReminder.clickInit = true;
			const reminderEl = document.querySelector( '.mdl_cartreminder' );
			document.addEventListener( 'click', ( ev ) => {
				if ( reminderEl.classList.contains( 'en_is_active' ) && ( ev.target && ( ev.target.matches( '.en_js_close_cartreminder' ) || !reminderEl.contains( ev.target ) ) ) ) {
					ev.preventDefault();
					window.dispatchEvent( new CustomEvent( 'closecartreminder.acl' ) );
				}
			} );
		}
	}
}

const initCartReminder = ( scopeEl = document ) => {
	const cartReminderEls = scopeEl.querySelectorAll( '.mdl_cartreminder' );
	cartReminderEls.forEach( ( cartReminderEl ) => {
		cartReminderEl.SL_CARTREMINDER ??= new CartReminder( cartReminderEl );
	} );
};

export { initCartReminder };
